import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import PropTypes from "prop-types";
import Svg from "_assets/svg";
import Button from "components/Button";
import styled from "styled-components";
import Wrapper from "./Wrapper";
import ButtonMenu from "./ButtonMenu";
import ButtonUser from "./ButtonUser";

const ImgClose = styled.img`
  width: 25px;
  height: 25px;
`;

const WrapperMenu = styled.div`
  position: fixed;
  top: 73px;
  left: 0px;
  width: 100vw;
  height: ${(props) => (props.activeMenu ? "calc(100vh - 73px)" : "0")};
  background: rgba(0, 0, 0, 0.8);
  transition: 0.5s;
  -webkit-transition: 0.5s;
  -o-transition: 0.5s;
  -moz-transition: 0.5s;
`;

const WrapperMenuContent = styled.div`
  display: ${(props) => (props.activeMenu ? "flex" : "none")} !important;
  background: #FFFFFF;
  width: 100%;
  padding: 15px; 20px;
`;

const MenuMobile = (props) => {
  const { isLogin } = props;
  const location = useLocation();
  const history = useHistory();
  const [activeMenu, setActiveMenu] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const userData = user?.user ?? null;

  function gotoApiDocumentation() {
    window.open('https://documentation.ocatelkom.co.id/oca-api-documentation/oca-api-documentation');
  }

  useEffect(() => {
    document.body.style.overflow = activeMenu ? "hidden" : "auto";
  }, [activeMenu]);
  return (
    <Wrapper>
      <ImgClose
        onClick={() => setActiveMenu(!activeMenu)}
        src={activeMenu ? Svg.ic_close.default : Svg.menu.default}
        alt=""
      />
      <WrapperMenu activeMenu={activeMenu}>
        <WrapperMenuContent activeMenu={activeMenu} className="d-flex flex-column">
          <ButtonMenu
            active={location.pathname.indexOf("/dashboard") >= 0}
            onClick={() => history.push("/dashboard")}
          >
            Overview
          </ButtonMenu>
          {isLogin && (
            <ButtonMenu
              active={location.pathname.indexOf("/my-application") >= 0}
              onClick={() => {
                history.push("/my-application");
                setActiveMenu(false);
              }}
              style={{ marginTop: 10 }}
            >
              My Application
            </ButtonMenu>
          )}
          {isLogin && (
            <ButtonMenu
              active={location.pathname.indexOf("/generate-report") >= 0}
              onClick={() => {
                history.push("/generate-report");
                setActiveMenu(false);
              }}
              style={{ marginTop: 10 }}
            >
              Generate Report
            </ButtonMenu>
          )}
          {isLogin && (
            <ButtonMenu
              active={location.pathname.indexOf("/whatsapp-template") >= 0}
              onClick={() => {
                history.push("/whatsapp-template");
                setActiveMenu(false);
              }}
              style={{ marginTop: 10 }}
            >
              Whatsapp Template
            </ButtonMenu>
          )}
          {/* <ButtonMenu
            active={location.pathname.indexOf("/docs") >= 0}
            onClick={() => {
              history.push("/docs");
              setActiveMenu(false);
            }}
            style={{ marginTop: 10 }}
          >
            API Documentation
          </ButtonMenu> */}
          <ButtonMenu
            active={location.pathname.indexOf("/docs") >= 0}
            onClick={() => {
              gotoApiDocumentation();
              setActiveMenu(false);
            }}
            style={{ marginTop: 10 }}
          >
            API Documentation
          </ButtonMenu>
          {false && (
            <ButtonMenu
              active={location.pathname.indexOf("/help") >= 0}
              onClick={() => {
                history.push("/help");
                setActiveMenu(false);
              }}
              style={{ marginTop: 10 }}
            >
              Help
            </ButtonMenu>
          )}

          {isLogin ? (
            <ButtonUser user={userData} />
          ) : (
            <div>
              <Button className="margin-right-15" primary>
                Login
              </Button>
              <Button>Register</Button>
            </div>
          )}
        </WrapperMenuContent>
      </WrapperMenu>
    </Wrapper>
  );
};

MenuMobile.propTypes = {
  isLogin: PropTypes.bool.isRequired,
};

export default MenuMobile;
